<style lang="stylus">
    .ShareBox-mask
        modal-mask()
        display flex
        align-items center
        justify-content center
        .ivu-icon-ios-arrow-down:before{
            color: #757575;
            content: "\F33D" !important
            background-image  none;
        }
        .dialog-title
            border: none;
            padding:  20px
            font-weight: 600
        .ShareBox-modal
            width 480px
            position relative
            left unset !important
            top unset !important
            transition all .3s ease
            &.loading
                overflow: hidden
            &.loading:after
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                z-index: 20;
                background: #fff;
                left: 0;
                top: 0;
                border-radius: 8px;
                background-image: url(../../assets/ProductIcon.svg);
                background-position: center center;
                background-size: 120px;
                background-repeat: no-repeat;
                @keyframes backimageanimate
                {
                    from {transform: scale(1)}
                    to {transform: scale(1.2)}
                }
                animation: backimageanimate 5s ease infinite alternate;
            .dialog-title
                .title-text
                    top 0
            .ShareBox-title
                display flex
                align-items center
                height 28px
                margin-bottom 24px;
                .ShareList
                    height 100%
                    font-size 14px
                    font-weight 400
                    line-height 16px
                    color var(--color-text-primary, rgba(34, 34, 34, 1))
                    cursor pointer
                    margin-right 24px
                .active-share
                    font-weight 700
                    color var(--themeColor, rgba(1, 127, 255, 1))
                    border-bottom 2px solid var(--themeColor, rgba(1, 127, 255, 1))
            .dialog-slot {
                padding 14px 0 24px 24px
            }
            .ShareBox-content
                position relative
            .ShareBox-body
                padding-bottom 0px
                padding-right 24px
                width 454px
                max-height 530px
                overflow auto
                background #FFF
                .link-switch{
                    display: flex;
                    align-items: center;
                    margin-bottom: 22px
                    .top-tips{
                      margin-left: 16px
                      font-size: 14px
                      max-width 330px
                    }
                    svg{
                      margin-left: 5px
                      margin-top: 2px
                      width: 12px
                      height: 12px
                    }
                    .ivu-switch-small{
                      width: 44px
                      height: 24px
                      border-radius: 31px;
                    }
                    .ivu-switch-small:after{
                      width: 16px
                      height: 16px
                      left: 3px
                      top: 3px
                    }
                    .ivu-switch-checked.ivu-switch-small:after{
                      left: 23px
                    }
                }
                .link-btn
                    margin-left: 16px;
                    width: 96px;
                    height: 32px
                    background-color: var(--themeColor);
                    border-radius: 6px;
                    &.disable
                        background #666
                    span
                        width 100%
                        display block
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                .ShareBox-link
                    display flex
                    align-items center
                    .link-box
                        border: 1px solid rgba(0, 0, 0, 0.06);
                        border-radius: 6px;
                        display: flex;
                        align-items: center;
                        flex: 1;
                        height: 32px;
                        .item-dropbox{
                          width: 273px
                          display: flex;
                          align-items: center;
                          .item-downs{
                            width: 302px
                          }
                          .down-arrow {
                            color var(--svg-color-primary)
                            }
                        }
                        input
                            outline: none !important;
                            border: 0;
                            flex: 1;
                            padding-left 12px
                        .refresh-icon
                            padding: 4px;
                            display: flex;
                            align-items: center;
                            margin-right 4px
                            margin-left 8px
                            padding-right 0
                            height 100%
                            border-left 1px solid rgba(0,0,0,0.08)
                            svg
                                cursor: pointer;
                                width: 24px;
                                height: 24px;
                                padding 4px
                                outline: none;
                            &:active
                                background: #ECECEC;
                                border-radius: 2px;
                .ShareBox-password
                    display flex
                    align-items center
                    justify-content space-between
                    margin-top 22px
                    height: 24px;
                    .right
                        display flex
                        align-items center
                    .tips
                        display flex
                        align-items center
                        span
                            font-size: 12px;
                            line-height: 16px;
                            color: #000000;
                        img
                            width 12px
                            height 12px
                            margin-left 4px
                            cursor pointer
                    .password-box
                        border: 1px solid #DCDEE1;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        height: 24px;
                        margin-right 8px
                        span
                            font-size: 10px;
                            line-height: 12px;
                            padding-right 12px
                            color: var(--themeColor);
                            text-decoration: underline;
                            cursor: pointer;
                        input
                            outline: none !important;
                            border: 0;
                            padding-left 12px
                            width: 70px;
                .ShareBox-date
                    display flex
                    align-items center
                    justify-content space-between
                    margin-top 16px
                    padding-bottom 16px
                    border-bottom 1px solid rgba(0, 0, 0, 0.06)
                    .tips
                        font-size: 12px;
                        line-height: 16px;
                        color: #000000;
                    .dropdown-expire
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        position relative

                        .ivu-icon-ios-arrow-down
                            transition: .3s transform;
                            &.active
                                transform: rotate(180deg);
                    .expire-list
                        z-index 1
                        background: #FFFFFF;
                        box-shadow: $box-shadow;
                        padding: 6px;
                        border-radius: 8px;
                        position: absolute;
                        right 0
                        top: calc(100% + 7px);
                        .expire-item
                            white-space: nowrap;
                            padding: 6px 10px 6px 26px;
                            position relative
                            border-radius: 6px;
                            display flex
                            justify-content space-between
                            align-items center
                            img
                                width 12px
                                height 12px
                                margin-left 8px
                            .text
                                font-size: 12px;
                                line-height: 16px;
                                color: #000000;
                            &:hover
                                background: #F3F3F3;
                            &.active
                                .text
                                    color: var(--themeColor);
                                &:before
                                    line-height: 0;
                                    content: url("data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%0A%20%20%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M5.94352%2010.5293L3.70711%208.29291C3.31658%207.90239%202.68342%207.90239%202.29289%208.29291C1.90237%208.68344%201.90237%209.3166%202.29289%209.70712L5.29289%2012.7071C5.70479%2013.119%206.38016%2013.0931%206.75926%2012.6508L12.7593%205.65081C13.1187%205.23148%2013.0701%204.60018%2012.6508%204.24076C12.2315%203.88134%2011.6002%203.9299%2011.2407%204.34923L5.94352%2010.5293Z%22%20fill%3D%22%23424242%22%2F%3E%0A%3C%2Fsvg%3E");
                                    position: absolute;
                                    display: block;
                                    left: 4px;
                                    top: 7px;
                                    width: 16px;
                                    height: 16px;

                .embed-tips
                    padding 16px
                    border-radius 6px
                    background rgba(1, 127, 255, 0.08)
                    color rgba(0, 0, 0, 0.5)
                    line-height 16px
                    .embed-tips-switch
                        display flex
                        height 18px
                        align-items center
                        margin-bottom 12px
                        font-size 14px
                        color rgba(34, 34, 34, 1)
                        span
                            margin-right 16px
                .embed-subtitle
                    margin 16px 0 12px 0
                    font-size 14px
                    line-height 18px
                    color rgba(34, 34, 34, 1)
                .embed-preview
                    display flex
                    align-items center
                    justify-content center
                    height 160px
                    margin-bottom 16px
                    border-radius 8px
                    border 1px solid rgba(0, 0, 0, 0.08)
                    img
                        max-width 100%
                        max-height 100%
                .embed-code
                    width 100%
                    height 32px
                    margin-bottom 16px
                    padding 0 8px
                    line-height 32px
                    border 0
                    border-radius 6px
                    background rgba(242, 244, 249, 1)
                .embed-bottom
                    display flex
                    justify-content space-between
                    .link-box
                        position relative
                        border: 1px solid rgba(0, 0, 0, 0.06);
                        box-sizing: border-box;
                        border-radius: 6px;
                        flex: 1;
                        height: 32px;
                        display: flex;
                        align-items: center;
                        .item-dropbox strong
                            margin-left 4px
                        .item-downs
                            width 318px
                            position absolute
                            left 0
                            top -86px
                            .item-down
                                height 32px
                                padding 0 10px
                                line-height 32px

                .ShareBox-member
                    .title
                        padding: 16px 0px 16px 0;
                    .member-list
                        padding-left: 0
                        padding-right: 4px
                        min-height: 32px;
                        max-height: 182px;
                        overflow: auto;
                        border-bottom 1px solid rgba(0, 0, 0, 0.06)
                        .member-item
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-bottom 16px
                            .member-avatar
                                display: flex;
                                align-items: center;
                                img
                                    width: 28px;
                                    height: 28px;
                                    margin-right 8px
                                    border-radius: 50%;
                                .no-icon
                                    text-align: center;
                                    color: #7a5923;
                                    font-size: 13px;
                                    width: 28px;
                                    height: 28px;
                                    line-height: 28px;
                                    margin-right 8px
                                    background: #fff8e5;
                                    border-radius: 50%;
                                .member-avatar-text
                                    max-width: 280px;
                                    user-select: text;
                                    font-size: 12px;
                                    line-height: 16px;
                                    color: #666666;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                .ShareBox-shareLink
                    margin-top: 20px
                    display: flex;
                    justify-content: space-between;
                    .ShareBox-left
                        .icon-wrapper
                            margin-top: 20px
                            display: flex;
                            flex-shrink 0
                            .ShareBox-icon
                                display: flex;
                                margin-right: 18px;
                                width: 24px;
                                height: 24px;
                                cursor: pointer;
                                transition: transform .2s linear;
                                position relative
                                .item-icon
                                    width: 24px;
                                    height: 24px;
                                    &:hover
                                        transform: scale(1.1);
                                .item-icon-code
                                    position absolute
                                    left calc(100% + 10px)
                                    transform: translateY(-50%);
                                    top: 50%;
                                    z-index: 1;
                    .ShareBox-right
                        padding: 8px
                        border: 1px solid rgba(0, 0, 0, 0.06);
                        border-radius: 8px;
                        text-align: center;
                        color: rgba(0, 0, 0, 0.6)
                        font-size: 10px;
                        line-height: 16px;
                        >img
                            height 98px
                        >p{
                            margin-top: 10px
                        }
                .invite-user
                    .title
                        font-weight: bold;
                        font-size: 12px;
                    .invite-link
                        display: flex;
                        align-items: center;
                        margin-top: 16px;
                        .link-box
                            border: 1px solid rgba(0, 0, 0, 0.06);
                            box-sizing: border-box;
                            border-radius: 6px;
                            flex: 1;
                            height: 32px;
                            display: flex;
                            align-items: center;
                            input
                                flex: 1;
                                outline: none !important;
                                border: 0px;
                                padding: 0px 13px;


                        .link-btn
                            margin-left: 6px;
                            width: 96px;
                            span
                                display block
                                width 100%
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap

                    .item-dropbox
                        width 90px
                        span
                            width calc(100% - 18px)

                .invite-type
                    padding: 26px 0px 22px 0px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
                    .title
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        span
                            font-weight: bold;
                            font-size: 12px;
                    .type
                        display: flex;
                        margin-top 16px;
                        .link-btn
                            margin-left 6px
                            width: 96px;
                            span
                                display block
                                width 100%
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap
                        .ivu-select
                            flex: 1;
                .item-dropbox
                    position relative
                    padding-left 10px
                    cursor: pointer;
                    >span
                        margin-right: 4px;
                        float left
                        display block
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap

                    .item-downs
                        z-index 1
                        position absolute
                        top calc(100% + 10px)
                        left 0
                        padding 6px
                        background: #FFFFFF;
                        box-shadow: $box-shadow;
                        border-radius: 8px;
                        .item-down
                            line-height: 28px;
                            height: 28px;
                            font-size: 12px;
                            padding: 0px 6px;
                            cursor: pointer;
                            width 100%
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            border-radius: 6px;

                            &.selected
                                background $main-selectcolor
                            &.active
                                color: $main-selectcolor;
                            &:hover:not(.selected)
                                background: $main-hovercolor;
            @media screen and (max-height: 910px) {
                .ShareBox-body {
                    max-height 430px
                }
            }
            .ShareBox-body_embed
                position absolute
                left 0
                top 0
                height 100%
                display flex
                flex-direction column
                .embed-preview
                    flex 1
    .notShowCancle
        .dialog-btnbox-normal
                .dialog-btn-ok + div
                    display: none;
    .disable
        opacity: 0.4;
        filter: grayscale(1);
        cursor: not-allowed;
        pointer-events: none

    .iframe-modal
        .preview-img
            border: 1px solid rgba(0,0,0,0.06);
            border-radius: 4px;
            width: 448px;
            height: 202px;
            overflow: hidden;
        .html-box
            .title
                padding 22px 0px 16px 0px
                font-size: 12px;
                line-height: 16px;
                color: #000000;
            .html-content
                border: 1px solid rgba(0,0,0,0.06);
                border-radius: 4px;
                width: 448px;
                overflow: auto;
                padding: 16px;
                outline: none;
                height: 125px;
                resize: none;
                &.external
                    height: 110px;
            .share-btn-wrap
                text-align: right;
                padding-top 25px
                .html-btn
                    min-width: 100px;
                    max-width 100%
                    span
                        display block
                        width 100%
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
</style>

<template>
    <div class="ShareBox-mask">
        <Dialog class="ShareBox-modal" :class="{ loading: showShareLoading }" :title="$t('title')" :isShow="true" ref="dialog" @close="closeModal">
            <div class="ShareBox-title">
                <div class="ShareList" @click="setActive('link')" :class="{ 'active-share': activeShare === 'link' }">
                    {{ $t("shareLink") }}
                </div>
                <div class="ShareList" @click="setActive('embed')" :class="{ 'active-share': activeShare === 'embed' }">
                    {{ $t("embedTitle") }}
                </div>
            </div>
            <div class="ShareBox-content">
                <div class="ShareBox-body">
                    <template v-if="internal">
                        <div class="link-switch">
                            <i-switch
                                :disabled="isShareEdit"
                                v-model="hasSwitch"
                                @on-change="handleChangeSwitch"
                                :loading="isLoadingSw"
                                size="small"
                            />
                            <span class="top-tips" v-show="hasSwitch">{{ $t("topTips") }}</span>
                            <span class="top-tips" v-show="!hasSwitch">{{ $t("topTipsClose") }}</span>
                            <iconSymbol :content="$t('topTipsHover')" v-tippy="{ placement: 'top' }" name="yiwen" />
                        </div>
                        <div class="ShareBox-link">
                            <div class="link-box">
                                <div
                                    class="item-dropbox"
                                    :class="{
                                        disable: !hasSwitch || isShareEdit || isPreviewView || isWorkwx,
                                    }"
                                    v-click-outside="closeType"
                                    @click.stop="toggleType('type1')"
                                >
                                    <span>
                                        <span v-if="isPreviewView">{{ shareTypeMap.get(0) }}</span>
                                        <span v-else>
                                            {{ $t("getLink") }},
                                            <strong>{{ getLinkTypeMap.get(shareType) }}</strong>
                                        </span>
                                    </span>
                                    <iconSymbol class="down-arrow" name="aiset-arrow" style="width: 8px; height: 8px"></iconSymbol>
                                    <div class="item-downs" v-show="showType === 'type1'">
                                        <div
                                            class="item-down"
                                            :class="{ selected: shareType == key }"
                                            v-for="[key, value] in getLinkTypeMap"
                                            :key="key"
                                            :title="value"
                                            @click.stop="
                                                shareType = key;
                                                setShareType();
                                            "
                                        >
                                            {{ $t("getLink") }},
                                            <strong>{{ value }}</strong>
                                        </div>
                                    </div>
                                </div>
                                <div class="refresh-icon">
                                    <iconSymbol
                                        :class="{ disable: !hasSwitch || isShareEdit }"
                                        :content="$t('refreshLink')"
                                        v-tippy="{ placement: 'top' }"
                                        name="refresh"
                                        @click.native="clickEventType('refreshLinkPrev')"
                                    />
                                </div>
                            </div>
                            <Button
                                class="link-btn"
                                :class="{ disable: !hasSwitch }"
                                type="primary"
                                :disabled="!hasSwitch"
                                @click="copyLink"
                                :content="$t('copyLink')"
                                v-tippy="{ placement: 'top' }"
                            >
                                {{ $t("copyLink") }}
                            </Button>
                        </div>
                        <div class="ShareBox-password">
                            <div class="tips">
                                <span>{{ $t("passCode") }}</span>
                                <VipIcon v-if="!vip" @click.native="showFrame(hasPass, expireType)" />
                            </div>
                            <div class="right">
                                <div class="password-box" v-if="hasPass">
                                    <input :value="shareLinkCode" readonly />
                                    <span
                                        :class="{ disable: !hasSwitch || isShareEdit }"
                                        @click="!clickLoading && !isShareEdit && clickEventType('resetPassword')"
                                    >
                                        {{ $t("changeCode") }}
                                    </span>
                                </div>
                                <i-switch
                                    :disabled="!hasSwitch || isShareEdit || embedSwitch === 1"
                                    v-model="hasPass"
                                    @click.native="switchPrivate"
                                    :loading="isLoadingSw"
                                    size="small"
                                />
                            </div>
                        </div>
                        <div class="ShareBox-date">
                            <span class="tips">{{ $t("setExpire") }}</span>
                            <div
                                class="dropdown-expire"
                                v-click-outside="closeType"
                                :class="{ disable: !hasSwitch || isShareEdit || embedSwitch === 1 }"
                            >
                                <div @click.stop="toggleType('type2')">
                                    <span style="margin-right: 4px">{{ activeDateString() }}</span>
                                    <i class="ivu-icon ivu-icon-ios-arrow-down" :class="{ active: showType == 'type2' }"></i>
                                </div>
                                <div v-show="showType == 'type2'" class="expire-list" @click.stop>
                                    <template v-for="[key, value] in expireMap">
                                        <div
                                            @click="closeExpireList(key)"
                                            class="expire-item"
                                            :class="{ active: key === expireType }"
                                            :key="key"
                                            v-if="key !== 4"
                                        >
                                            <span>{{ value }}</span>
                                            <VipIcon v-if="!vip && ![5, 6].includes(key)" />
                                        </div>
                                        <DatePicker
                                            ref="datePicker"
                                            :options="dateOptions"
                                            v-else
                                            :open="openDatePicker"
                                            v-model="expireDate"
                                            type="date"
                                            placement="left-start"
                                            @on-change="closeExpireList(key)"
                                            @on-open-change="checkExpireListPop"
                                            :transfer="true"
                                            :key="key"
                                        >
                                            <div
                                                class="expire-item"
                                                :class="{ active: key === expireType }"
                                                @mouseenter.stop="openDatePicker = true"
                                                @mouseleave="checkLeaveTarget"
                                            >
                                                <span>{{ value }}</span>
                                                <VipIcon v-if="!vip" />
                                            </div>
                                        </DatePicker>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="invite-user">
                            <div class="title">{{ $t("inviteUser") }}</div>
                            <div class="invite-link">
                                <div class="link-box" :class="{ disable: isShareEdit }">
                                    <input :placeholder="$t('email')" :readonly="isShareEdit" v-model="email" type="text" />
                                    <div
                                        class="item-dropbox"
                                        :class="{
                                            disable: isShareEdit || isPreviewView || isTeamsApp,
                                        }"
                                        v-click-outside="closeType"
                                        @click.stop="toggleType('type3')"
                                    >
                                        <span
                                            v-text="getPreviewLimit(shareTypeMap.get(inviteType))"
                                            :title="getPreviewLimit(shareTypeMap.get(inviteType))"
                                        ></span>
                                        <Icon class="ios-arrow" type="ios-arrow-down" />
                                        <div class="item-downs" v-show="showType === 'type3'">
                                            <div
                                                class="item-down"
                                                v-for="[key, value] in shareTypeMap"
                                                :key="key"
                                                :value="key"
                                                @click.stop="
                                                    inviteType = key;
                                                    closeType();
                                                "
                                            >
                                                {{ value }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Button
                                    class="link-btn"
                                    type="primary"
                                    :class="{ disable: !emailTest || isShareEdit }"
                                    @click="emailTest && !isShareEdit && clickEventType('inviteMember')"
                                    :content="$t('sendInvite')"
                                    v-tippy="{ placement: 'top' }"
                                >
                                    {{ $t("sendInvite") }}
                                </Button>
                            </div>
                        </div>
                        <div class="invite-type">
                            <div class="title">
                                <span>{{ $t("inviteLink") }}</span>
                                <i-switch
                                    :disabled="isShareEdit"
                                    v-model="shareUseable"
                                    :true-value="1"
                                    :false-value="0"
                                    @on-change="clickEventType('setShareUsable')"
                                    size="small"
                                />
                            </div>
                            <div class="type">
                                <Input
                                    v-if="isShareEdit || isPreviewView || !shareUseable || isTeamsApp"
                                    type="text"
                                    readonly
                                    :value="shareTypeString"
                                />
                                <i-select v-else v-model="shareType" @on-change="setShareType" style="width: 200px">
                                    <i-option v-for="[key, value] in shareLinkTypeMap" :key="key" :value="key">{{ value }}</i-option>
                                </i-select>
                                <Button
                                    class="link-btn"
                                    type="primary"
                                    :class="{ disable: !shareUseable }"
                                    @click="shareUseable && copyLink()"
                                    :content="$t('copyLink')"
                                    v-tippy="{ placement: 'top' }"
                                >
                                    {{ $t("copyLink") }}
                                </Button>
                            </div>
                        </div>
                    </template>
                    <div class="ShareBox-member" v-if="!isWorkwx">
                        <div class="title">
                            {{ $t("joinMembers") }}
                        </div>
                        <div class="member-list">
                            <div class="member-item" v-for="(item, index) in shareMembers" :key="item.uuid">
                                <div class="member-avatar">
                                    <img :src="item.avatar_url" v-if="item.avatar_url" alt="" />
                                    <div class="no-icon" v-else>
                                        {{ getFirstName(item.nick_name || item.email) }}
                                    </div>
                                    <div class="member-avatar-text" :title="item.nick_name || item.email">{{ item.nick_name || item.email }}</div>
                                </div>
                                <div
                                    class="item-dropbox join-dropbox"
                                    :class="{ disable: isShareEdit || isPreviewView }"
                                    @click.stop="toggleMemberType($event, index)"
                                    v-click-outside="() => (memberShowType = -1)"
                                >
                                    <span v-text="item.option != 2 ? getPreviewLimit(shareTypeMap.get(item.option)) : $t('owner')"></span>
                                    <Icon class="ios-arrow" type="ios-arrow-down" v-if="item.option !== 2" />
                                    <div class="item-downs" v-if="item.option !== 2" :style="memberTypeStyle" v-show="memberShowType == index">
                                        <div
                                            class="item-down"
                                            @click="changeMemberStype(item, key)"
                                            v-for="[key, value] in shareTypeMap"
                                            :key="key"
                                            :title="value"
                                            @click.stop="item.option = key"
                                        >
                                            {{ value }}
                                        </div>
                                        <div class="item-down" @click="removeMember(item, index)">
                                            {{ $t("remove") }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ShareBox-shareLink">
                        <div class="ShareBox-left">
                            <p>{{ $t("shareType") }}</p>
                            <div class="icon-wrapper">
                                <div class="ShareBox-icon" v-for="item in iconList" :key="item.id">
                                    <template v-if="item.name === 'twitter'">
                                        <img class="item-icon" @click.stop="clickIcon(item.id)" src="@/public/img/xlogo.svg" />
                                    </template>
                                    <template v-else>
                                        <iconSymbol @click.native.stop="clickIcon(item.id)" class="item-icon" :name="item.name"></iconSymbol>
                                    </template>
                                    <div
                                        v-click-outside="closeType"
                                        v-show="showType === 'type4'"
                                        class="item-icon-code"
                                        v-if="item.name == 'wechat' || item.name == 'line'"
                                    >
                                        <img :src="QRCodeData" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ShareBox-right">
                            <img :src="QRCodeData" alt="" />
                            <p>{{ $t("scanCode") }}</p>
                        </div>
                    </div>
                </div>
                <div v-if="activeShare === 'embed'" class="ShareBox-body ShareBox-body_embed">
                    <div class="embed-tips">
                        <div class="embed-tips-switch">
                            <span>{{ $t("embedTitle") }}</span>
                            <i-switch
                                v-model="embedSwitch"
                                :true-value="1"
                                :false-value="0"
                                :disabled="isShareEdit"
                                :loading="internal && isLoadingSw"
                                size="small"
                                @on-change="handleEmbedSwitchChange()"
                            />
                        </div>
                        <div v-if="internal">{{ $t("embedTipsIn") }}</div>
                        <div v-else>{{ $t("embedTips") }}</div>
                    </div>
                    <div class="embed-subtitle">{{ $t("preview") }}</div>
                    <div class="embed-preview">
                        <img :src="previewUrl" class="preview-img" alt="" />
                    </div>
                    <input class="embed-code" v-model="embedCode" readonly />
                    <div class="embed-bottom">
                        <div class="link-box">
                            <div
                                class="item-dropbox"
                                :class="{
                                    disable: embedSwitch === 0,
                                }"
                                v-click-outside="closeType"
                                @click.stop="toggleType('shareType')"
                            >
                                <span>
                                    {{ $t("allNetworkUser") }}
                                    <strong>{{ shareType === 0 ? $t("canView") : $t("canEdit") }}</strong>
                                </span>
                                <iconSymbol class="down-arrow" name="aiset-arrow" style="width: 8px; height: 8px"></iconSymbol>
                                <div class="item-downs" v-show="showType === 'shareType'">
                                    <div class="item-down" :class="{ selected: shareType === 0 }" @click.stop="shareTypeClickHandler(0)">
                                        {{ $t("canView") }}
                                    </div>
                                    <div class="item-down" :class="{ selected: shareType === 1 }" @click.stop="shareTypeClickHandler(1)">
                                        {{ $t("canEdit") }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Button
                            class="link-btn"
                            :class="{ disable: embedSwitch === 0 }"
                            type="primary"
                            :content="$t('copyCode')"
                            v-tippy="{ placement: 'top' }"
                            @click="copyEmbedCode()"
                        >
                            {{ $t("copyCode") }}
                        </Button>
                    </div>
                </div>
            </div>
        </Dialog>
        <Modal v-model="showIframeDialog" :title="$t('title')" :width="480" :footer-hide="true" :styles="{ top: 'calc(50% - 273px)' }">
            <div class="iframe-modal">
                <div style="margin-bottom: 10px">Iframe</div>
                <img :src="previewUrl" class="preview-img" alt="" />
                <!-- <img :src="item" class="preview-img" alt="" v-for="(item,key) in previewUrls" :key="key"> -->
                <div class="html-box">
                    <div class="title">
                        {{ $t("useHTML") }}
                    </div>
                    <textarea class="html-content" :class="{ external: !internal }" v-model="shareHTML" readonly />
                    <div class="share-btn-wrap">
                        <Button class="html-btn" type="primary" @click="copyText('html')" :content="$t('copyCode')" v-tippy="{ placement: 'top' }">
                            {{ $t("copyCode") }}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject, Watch } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    import { addJs } from "@/public/utils/tool";
    import axios from "axios";
    import appConfig from "@/public/globalConfig";
    import type VueComponent from "vue";
    declare var qrcode: any;
    declare var egSize: any;

    @Component({
        components: {
            Dialog,
        },
    })
    export default class ShareBox extends Vue {
        @Inject()
        ["showMessage"];

        QRCodeData: string = "";
        activeShare: string = "link";
        shareTimer = null;
        shareCancel = null;
        isLoadingSw: boolean = false;
        hasPass = !!this.$store.state.ui.shareLinkCode;
        hasSwitch = !!this.switch;
        showType = "";
        embedSwitch = 0;

        buildLang = appConfig.language;
        toggleType(type) {
            this.showType = this.showType === type ? "" : type;
        }
        preventMenuClose = false;
        closeType() {
            if (this.preventMenuClose) return;
            this.showType = "";
        }

        shareTypeClickHandler(value) {
            this.shareType = value;
            this.setShareType();
        }

        memberTypeStyle = {};
        memberShowType = -1;
        toggleMemberType(e, index) {
            const pos = e.currentTarget.getBoundingClientRect();
            this.memberTypeStyle = {
                position: "fixed",
                left: pos.left + "px",
                top: pos.top + pos.height + 10 + "px",
                width: "100px",
            };
            this.memberShowType = index === this.memberShowType ? -1 : index;
        }
        get shareType() {
            return this.$store.state.ui.shareType;
        }
        set shareType(v) {
            this.$store.commit("setStatus", {
                type: "shareType",
                data: v,
            });
        }
        get shareTypeMap() {
            if (this.isWorkwx) {
                return new Map([[0, this.$t("view")]]);
            }
            return new Map([
                [0, this.$t("view")],
                [1, this.$t("edit")],
            ]);
        }
        get shareLinkTypeMap() {
            return new Map([
                [0, this.$t("viewLink")],
                [1, this.$t("editLink")],
            ]);
        }
        get getLinkTypeMap() {
            return new Map([
                [0, this.$t("canView")],
                [1, this.$t("canEdit")],
            ]);
        }
        getPreviewLimit(value) {
            return this.isPreviewView ? this.shareTypeMap.get(0) : value;
        }
        setShareType() {
            this.setOption(this.shareType);
            let trackType = this.shareType == 0 ? "viewonly" : "canedit";
            this.$track("share", "Permissionselection", `permissiontype: ${trackType}`);
            if (this.shareType == 1 && !this.internal) {
                this.showShareEditTips();
            }
        }
        get shareTypeString() {
            return this.shareLinkTypeMap.get(this.shareType);
        }
        get shareUseable() {
            return this.$store.state.ui.shareUseable;
        }
        set shareUseable(v) {
            this.$store.commit("setStatus", {
                type: "shareUseable",
                data: v,
            });
        }
        showShareEditTips() {
            this.showMessage({
                type: 0,
                imgType: 0,
                content: this.$t("shareEditTips"),
                avoid: true,
                avoidTitle: "shareEditTip",
                sponsor: "shareEditSponsor",
                uniqueListenr: true,
                msgClass: "notShowCancle",
            });
        }

        setOption(type) {
            let query = this.shareLink.split("?").pop();
            let uuid = new URLSearchParams(query).get("code");
            let params = {
                option: type,
            };
            let ts = this;
            let url = `${this.urls.apiUrl}/api/user/${this.userInfo.user_id}/max/share/edit/${uuid}`;
            if (this.isPrivate) {
                url = `${this.urls.apiUrl}/api/web/user/${this.userInfo.user_id}/max/share/edit/${uuid}`;
            }
            axios
                .put(url, params, {
                    headers: {
                        Authorization: "Bearer " + this.userInfo.token,
                    },
                    cancelToken: new axios.CancelToken(function executor(c) {
                        ts.shareCancel = c;
                    }),
                })
                .then((response) => {
                    // console.log(true);
                });
            this.closeType();
        }
        get iconList() {
            return [
                {
                    id: 0,
                    name: "wechat",
                    lang: "zh",
                },
                {
                    id: 2,
                    name: "qq",
                    lang: "zh",
                },
                {
                    id: 1,
                    name: "sina",
                    lang: "zh",
                },
                {
                    id: 3,
                    name: "qzone",
                    lang: "zh",
                },
                {
                    id: 4,
                    name: "facebook",
                    lang: "en",
                },
                {
                    id: 5,
                    name: "twitter",
                    lang: "en",
                },

                {
                    id: 6,
                    name: "pinterest",
                    lang: "en",
                },
                {
                    id: 8,
                    name: "line",
                    lang: "en",
                },
                {
                    id: 9,
                    name: "iframe",
                    lang: "zh",
                },
            ].filter((item) => item.lang == this.buildLang);
        }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        get shareLinkCode() {
            return this.$store.state.ui.shareLinkCode;
        }
        set shareLinkCode(v) {
            this.$store.commit("setStatus", {
                type: "shareLinkCode",
                data: v,
            });
        }
        setActive(type: string) {
            if (type === "link") {
                this.activeShare = "link";
            } else {
                this.activeShare = "embed";
            }
        }
        handleChangeSwitch(v) {
            this.$edApi.setShareUsable({
                share_id: this.$store.state.ui.shareId,
                switch: v ? 1 : 0,
                id: this.userInfo.user_id,
                token: this.userInfo.token,
            });

            if (!v && this.embedSwitch === 1) {
                this.embedSwitch = 0;
                this.setEmbedSwitch();
            }
        }
        setEmbedSwitch() {
            this.$edApi.setShareUsable({
                share_id: this.$store.state.ui.shareId,
                embed_switch: this.embedSwitch,
                id: this.userInfo.user_id,
                token: this.userInfo.token,
            });
        }
        handleEmbedSwitchChange() {
            // 关闭嵌入第三方，只需要记录状态即可
            if (this.embedSwitch === 0) {
                this.setEmbedSwitch();
                return;
            }

            // 开启嵌入第三方，则需要开启链接分享，且设置无密码保护和永久有效
            if (this.internal) {
                if (!this.hasSwitch) {
                    this.hasSwitch = true;
                    this.handleChangeSwitch(this.hasSwitch);
                }
                if (this.hasPass || this.expireType !== 1) {
                    this.hasPass = false;
                    this.expireType = 1;
                    this.updateShareInfo({
                        end_type: 1,
                        private: false,
                    });
                }
            } else {
                if (this.shareUseable !== 1) {
                    this.shareUseable = 1;
                    this.clickEventType("setShareUsable");
                }
            }
            this.setEmbedSwitch();
        }
        showFrame(pass, type) {
            let triggerName = this.getShareTrigger(pass, type);
            this.$openBuyPage(triggerName);
        }
        switchPrivate() {
            if (!this.hasSwitch) return;
            return new Promise((resolve, reject) => {
                if (!this.vip) {
                    this.showFrame(!this.hasPass, this.expireType);
                    this.hasPass = false;
                    reject();
                    return;
                }
                let id = this.$store.state.ui.shareId;
                this.isLoadingSw = true;
                let params = {
                    exp: Math.round((new Date().getTime() + 100000000000) / 1000),
                    private: this.hasPass,
                };
                let ts: any = this;
                let url = `${this.urls.apiUrl}/api/user/${this.userInfo.user_id}/max/share/${id}`;
                if (this.isPrivate) {
                    url = `${this.urls.apiUrl}/api/web/user/${this.userInfo.user_id}/max/share/${id}`;
                }
                axios
                    .put(url, params, {
                        headers: {
                            Authorization: "Bearer " + this.userInfo.token,
                        },
                        cancelToken: new axios.CancelToken(function executor(c) {
                            ts.shareCancel = c;
                        }),
                    })
                    .then((response) => {
                        clearTimeout(this.shareTimer);
                        if (response.data.data && response.data.data.code) {
                            this.shareLinkCode = response.data.data.code;
                            this.$track("share", "password", "type: addpassword");
                        } else {
                            this.shareLinkCode = null;
                            this.$track("share", "password", "type: deletepassword");
                        }
                        this.isLoadingSw = false;
                        resolve();
                    });
            });
        }
        clickIcon(id) {
            let url = "";
            let shareLink = encodeURIComponent(this.shareLink);
            switch (id) {
                case 0:
                    this.toggleType("type4");
                    if (this.showType === "type4") {
                        this.$track("modal", "file", "share to weixin");
                        this.$nextTick(() => {
                            this.$el.querySelector(".item-icon-code").scrollIntoView({
                                block: "end",
                            });
                        });
                    }
                    break;
                case 1:
                    this.$track("modal", "file", "share to weibo");
                    this.sensors.track("copyShareLink", {
                        Catalogues: "saveFileProcess",
                        savesource: "shareSave",
                        file_source: this.$store.state.user.file_source,
                        template_type: this.$store.state.user.template_type,
                        share_way: "weibo",
                    });
                    this.sensors.track("shareComplete", {
                        Catalogues: "saveFileProcess",
                        share_way: "shareWeibo",
                    });
                    url = `http://service.weibo.com/share/share.php?url=${shareLink}&type=button&style=number&appkey=3113778129&title=${this.shareData.title}&pic=${this.shareData.imgUrl}&ralateUid=6009693789&language=zh_cn`;
                    this.openLink(url);
                    break;
                case 2:
                    this.$track("modal", "file", "share to qq");
                    this.sensors.track("copyShareLink", {
                        Catalogues: "saveFileProcess",
                        savesource: "shareSave",
                        file_source: this.$store.state.user.file_source,
                        template_type: this.$store.state.user.template_type,
                        share_way: "qq",
                    });
                    this.sensors.track("shareComplete", {
                        Catalogues: "saveFileProcess",
                        savesource: "shareSave",
                        share_way: "shareQQ",
                    });
                    url = `https://connect.qq.com/widget/shareqq/index.html?url=${shareLink}&title=${this.shareData.title}&desc=&pics=${this.shareData.imgUrl}&summary=Powered by EdrawMax`;
                    this.openLink(url);
                    break;
                case 3:
                    this.$track("modal", "file", "share to qzone");
                    this.sensors.track("copyShareLink", {
                        Catalogues: "saveFileProcess",
                        savesource: "shareSave",
                        file_source: this.$store.state.user.file_source,
                        template_type: this.$store.state.user.template_type,
                        share_way: "qzone",
                    });
                    this.sensors.track("shareComplete", {
                        Catalogues: "saveFileProcess",
                        savesource: "shareSave",
                        share_way: "shareQzone",
                    });
                    url = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${shareLink}&title=${this.shareData.title}`;
                    this.openLink(url);
                    break;
                case 4:
                    this.$track("modal", "file", "share to facebook");
                    this.sensors.track("copyShareLink", {
                        Catalogues: "saveFileProcess",
                        savesource: "shareSave",
                        file_source: this.$store.state.user.file_source,
                        template_type: this.$store.state.user.template_type,
                        share_way: "facebook",
                    });
                    this.sensors.track("shareComplete", {
                        Catalogues: "saveFileProcess",
                        savesource: "shareSave",
                        share_way: "shareFacebook",
                    });
                    url = `https://www.facebook.com/dialog/feed?app_id=309686709396813&display=page&link=${shareLink}&redirect_uri=https://www.facebook.com`;
                    this.openLink(url);
                    break;
                case 5:
                    this.$track("modal", "file", "share to twitter");
                    this.sensors.track("copyShareLink", {
                        Catalogues: "saveFileProcess",
                        savesource: "shareSave",
                        file_source: this.$store.state.user.file_source,
                        template_type: this.$store.state.user.template_type,
                        share_way: "twitter",
                    });
                    this.sensors.track("shareComplete", {
                        Catalogues: "saveFileProcess",
                        savesource: "shareSave",
                        share_way: "shareTwitter",
                    });
                    url = `https://twitter.com/intent/tweet?url=${shareLink}&text=${this.shareData.title}&via=edrawsoft&hashtags=edraw%2Cdemo`;
                    this.openLink(url);
                    break;
                case 6:
                    this.$track("modal", "file", "share to pinterest");
                    this.sensors.track("copyShareLink", {
                        Catalogues: "saveFileProcess",
                        savesource: "shareSave",
                        file_source: this.$store.state.user.file_source,
                        template_type: this.$store.state.user.template_type,
                        share_way: "pinterest",
                    });
                    this.sensors.track("shareComplete", {
                        Catalogues: "saveFileProcess",
                        savesource: "shareSave",
                        share_way: "sharePinterest",
                    });
                    url = `https://www.pinterest.com/pin/create/button/?guid=&url=${shareLink}&media=${this.shareData.imgUrl}&description=Powered by EdrawMax`;
                    this.openLink(url);
                    break;
                case 7:
                    this.$track("modal", "file", "share to linkedin");
                    this.sensors.track("copyShareLink", {
                        Catalogues: "saveFileProcess",
                        savesource: "shareSave",
                        file_source: this.$store.state.user.file_source,
                        template_type: this.$store.state.user.template_type,
                        share_way: "linkedin",
                    });
                    this.sensors.track("shareComplete", {
                        Catalogues: "saveFileProcess",
                        savesource: "shareSave",
                        share_way: "shareLinkedin",
                    });
                    url = `https://www.linkedin.com/shareArticle?mini=true&url=${shareLink}`;
                    this.openLink(url);
                    break;
                case 8:
                    this.toggleType("type4");
                    if (this.showType === "type4") {
                        this.$track("modal", "file", "share to line");
                        this.sensors.track("copyShareLink", {
                            Catalogues: "saveFileProcess",
                            savesource: "shareSave",
                            file_source: this.$store.state.user.file_source,
                            template_type: this.$store.state.user.template_type,
                            share_way: "line",
                        });
                        this.sensors.track("shareComplete", {
                            Catalogues: "saveFileProcess",
                            savesource: "shareSave",
                            share_way: "shareLine",
                        });
                        this.$nextTick(() => {
                            this.$el.querySelector(".item-icon-code").scrollIntoView({
                                block: "end",
                            });
                        });
                    }
                    break;
                case 9:
                    this.showIframeDialog = true;
                    break;
                default:
                    break;
            }
        }
        toSelLink() {
            (this.$refs.hideLinkInput as any).select();
        }
        openLink(url) {
            // 打开新标签
            let newTab = window.open("about:blank");
            newTab.location.href = url;
        }
        create_qrcode(text) {
            qrcode.stringToBytes = qrcode.stringToBytesFuncs["UTF-8"];
            let qr = qrcode(0, "H");
            qr.addData(text, "Byte");
            qr.make();
            return qr.createSvgTag(2, 0);
        }
        createQRCode() {
            if (this.shareLink == "") return;
            this.QRCodeData = "data:image/svg+xml;utf8," + this.create_qrcode(this.shareLink);
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        get shareLink() {
            return this.$store.state.ui.shareLink;
        }
        @Watch("shareLink")
        shareLinkChange(val) {
            if (val) {
                this.createQRCode();
            }
        }
        set shareLink(v) {
            this.$store.commit("setStatus", {
                type: "shareLink",
                data: v,
            });
        }
        get shareHTML() {
            return this.$store.state.ui.shareHTML;
        }
        get shareData() {
            return this.$store.state.ui.shareData;
        }
        get embedCode() {
            if (this.embedSwitch === 0) {
                return "";
            }
            return `<iframe src="${this.shareLink}&embed=1" frameborder="0" sandbox="allow-scripts allow-popups allow-top-navigation-by-user-activation allow-forms allow-same-origin allow-storage-access-by-user-activation allow-popups-to-escape-sandbox" allowfullscreen style="width: 768px; height: 432px; background-color: white;"></iframe>`;
        }
        changeMemberStype(item, option) {
            let id = this.$store.state.ui.shareId;
            let params: any = {
                share_id: id,
                user_id: item.user_id,
                option,
            };
            if (!item.user_id) {
                params.email = item.email;
                delete params.user_id;
            }
            axios.post(`${this.prefixHttp}${this.userInfo.user_id}/max/share/member`, params, {
                headers: {
                    Authorization: "Bearer " + this.userInfo.token,
                },
            });
            this.memberShowType = -1;
        }
        removeMember(item, index) {
            let id = this.$store.state.ui.shareId;
            let params: any = {
                share_id: id,
                user_id: item.user_id,
            };
            if (!item.user_id) {
                params.email = item.email;
                delete params.user_id;
            }
            axios
                .delete(`${this.prefixHttp}${this.userInfo.user_id}/max/share/member/remove`, {
                    params,
                    headers: {
                        Authorization: "Bearer " + this.userInfo.token,
                    },
                })
                .then(() => {
                    this.shareMembers.splice(index, 1);
                });
            this.memberShowType = -1;
        }
        dateOptions = {
            disabledDate(date) {
                return date && date.valueOf() < new Date(new Date().toLocaleDateString()).getTime();
            },
        };
        get prefixHttp() {
            if (this.isPrivate) {
                return `${this.urls.apiUrl}/api/web/user/`;
            }
            return `${this.urls.apiUrl}/api/user/`;
        }
        updateShareInfo(data) {
            return new Promise((res, rej) => {
                let id = this.$store.state.ui.shareId;
                axios
                    .put(`${this.prefixHttp}${this.userInfo.user_id}/max/share/${id}`, Object.assign({ private: this.hasPass }, data), {
                        headers: {
                            Authorization: "Bearer " + this.userInfo.token,
                        },
                    })
                    .then((response) => {
                        res(response.data.data);
                    })
                    .catch(() => {
                        rej();
                    });
            });
        }
        getFirstName(nick_name: string) {
            return nick_name.trim().split("")[0];
        }
        email = "";
        get emailTest() {
            return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email);
        }
        get expireMap() {
            return new Map([
                [1, this.$t("expire1")],
                [5, this.$t("expire5")],
                [6, this.$t("expire6")],
                [2, this.$t("expire2")],
                [3, this.$t("expire3")],
                [4, this.$t("expire4")],
            ]);
        }
        // 分享相关操作的埋点（付费卡点场景）
        getShareTrigger(toPass, toType) {
            let expireMap = new Map([
                [1, "Never"],
                [5, "1Day"],
                [6, "3Day"],
                [2, "7Day"],
                [3, "30Day"],
                [4, "Custom"],
            ]);
            let buyTrigger = `share_${toPass ? "Turn" : "Off"}_${expireMap.get(toType)}`;
            return buyTrigger;
        }
        expireType = 5;
        openDatePicker = false;
        expireDate: Date = new Date();
        closeExpireList(type: number) {
            let triggerName = this.getShareTrigger(this.hasPass, type);
            if ([1, 2, 3, 4].includes(type) && !this.$checkAuth({ type: "others", buyTrigger: triggerName }, "buyframe")) {
                this.getCurrentExpire();
                return;
            }
            // let passTime = Math.round((new Date().getTime() - new Date(new Date().toLocaleDateString()).getTime()) / 1000); // 当天已过去时间
            this.expireType = type;
            this.closeType();
            this.openDatePicker = false;
            let data = {
                end_type: this.expireType,
                end_time: this.expireDate && type == 4 ? this.expireDate.getTime() / 1000 + 86399 : "",
            };
            if (this.expireType !== 4) delete data.end_time;
            this.updateShareInfo(data).then((res: any) => {
                if (this.expireType == 1) {
                    this.expireDate = new Date();
                } else {
                    this.expireDate = new Date(res?.end_time * 1000);
                }
                this.$edMessage.success(this.$t("updateSucc"));
            });
        }
        checkExpireListPop(flag) {
            if (flag) {
                this.preventMenuClose = true;
                this.$nextTick(() => {
                    const children = (this.$refs.datePicker as VueComponent)[0]?.$children;
                    const vNode = children && children.find((item) => item.$el.className.indexOf("ivu-date-picker-transfer") != -1);
                    const dom = vNode && vNode.$el;
                    if (dom) {
                        dom.onmouseleave = () => {
                            dom.onmouseleave = null;
                            this.openDatePicker = false;
                        };
                    }
                });
            } else {
                this.$nextTick(() => {
                    this.preventMenuClose = false;
                });
            }
        }
        checkLeaveTarget(e) {
            const children = (this.$refs.datePicker as VueComponent)[0]?.$children;
            const vNode = children && children.find((item) => item.$el.className.indexOf("ivu-date-picker-transfer") != -1);
            const dom = vNode && vNode.$el;
            if (dom && e.toElement && !(e.toElement == dom || dom.contains(e.toElement))) {
                this.openDatePicker = false;
            }
        }
        activeDateString() {
            if (this.expireType == 1) {
                return this.expireMap.get(1);
            } else {
                if (this.lang == "zh") {
                    return this.expireDate.toLocaleString() + this.$t("activeDateSuffix");
                } else {
                    return this.$t("activeDateSuffix") + this.expireDate.toLocaleString();
                }
            }
        }
        get shareExpire() {
            return this.$store.state.ui.shareExpire;
        }
        @Watch("shareExpire")
        shareExpireChange() {
            this.initExpire();
            if (!this.isShareEdit && !this.isWorkwx) {
                this.getShareMembers();
            }
        }
        inviteType = 0;
        clickLoading = false;
        clickEventType(type: string) {
            let share_id = this.$store.state.ui.shareId;
            const map = new Map([
                [
                    "refreshLinkPrev",
                    () => {
                        this.showMessage({
                            sponsor: "shareBox",
                            type: 0,
                            uniqueListenr: true,
                            title: this.$t("refreshWarningTitle"),
                            content: this.$t("refreshWarning"),
                        });
                    },
                ],
                [
                    "inviteMember",
                    async () => {
                        // 无需去重处理
                        // if(~this.shareMembers.findIndex(item=> [item.email, this.userInfo.email].includes(this.email))){
                        //     this.email = ""
                        //     return
                        // }
                        if (this.clickLoading) return;
                        let data = {
                            id: this.userInfo.user_id,
                            token: this.userInfo.token,
                            option: this.inviteType,
                            email: this.email,
                            share_id,
                        };
                        try {
                            this.clickLoading = true;
                            await this.$edApi.inviteMember(data);
                            if (!~this.shareMembers.findIndex((item) => [item.email, this.userInfo.email].includes(this.email))) {
                                const item = {
                                    option: this.inviteType,
                                    email: this.email,
                                };
                                const temp_url = URL.createObjectURL(new Blob([JSON.stringify(item)], { type: "text/plain" }));
                                const uuid = temp_url.toString();
                                URL.revokeObjectURL(temp_url);
                                this.shareMembers.push(
                                    Object.assign(
                                        {
                                            uuid,
                                        },
                                        item
                                    )
                                );
                            }
                            this.$edMessage.success(this.$t("sendInviteSucc"));
                            this.clickLoading = false;
                        } catch (error) {
                            this.clickLoading = false;
                        }
                    },
                ],
                [
                    "resetPassword",
                    async () => {
                        try {
                            this.clickLoading = true;
                            const data: any = await this.updateShareInfo({ reset_pwd: 1 });
                            this.shareLinkCode = data.code;
                            this.clickLoading = false;
                        } catch (error) {
                            this.clickLoading = false;
                        }
                    },
                ],
                [
                    "setShareUsable",
                    () => {
                        this.$edApi.setShareUsable({
                            share_id,
                            switch: this.shareUseable,
                            id: this.userInfo.user_id,
                            token: this.userInfo.token,
                        });
                        if (!this.shareUseable && this.embedSwitch === 1) {
                            this.embedSwitch = 0;
                            this.setEmbedSwitch();
                        }
                    },
                ],
            ]);
            map.has(type) && map.get(type)();
        }
        initExpire() {
            if (this.shareExpire.end_type) {
                this.expireType = this.shareExpire.end_type;
            }
            if (this.shareExpire.end_time) {
                this.expireDate = new Date(this.shareExpire.end_time * 1000);
            }
            this.getCurrentExpire();
        }
        get shareMembers() {
            return this.$store.state.ui.shareMembers;
        }
        set shareMembers(v) {
            this.$store.commit("setStatus", {
                type: "shareMembers",
                data: v,
            });
        }
        get switch() {
            return this.$store.state.ui.switch;
        }
        get isShareEdit() {
            return Boolean(this.$store.state.ui.shareUUID);
        }
        get isPreviewView() {
            return this.$store.state.ui.isPreviewView;
        }
        get showShareLoading() {
            return this.$store.state.ui.ShareLoading;
        }
        @Watch("showShareLoading")
        watchShareLoading(val) {
            if (!val) {
                this.initExpire();
                if (!this.isShareEdit && !this.isWorkwx) {
                    this.getShareMembers();
                }
            }
        }
        getShareMembers() {
            if (!this.$store.state.ui.shareId) return;
            this.$edApi
                .getMembers({
                    id: this.userInfo.user_id,
                    shareId: this.$store.state.ui.shareId,
                    token: this.userInfo.token,
                })
                .then((data) => {
                    this.embedSwitch = data.embed_switch ?? 0;
                    this.shareMembers = data.member.map((item) => {
                        const temp_url = URL.createObjectURL(new Blob([JSON.stringify(item)], { type: "text/plain" }));
                        const uuid = temp_url.toString();
                        URL.revokeObjectURL(temp_url);
                        return {
                            ...item,
                            uuid,
                        };
                    });
                    this.$nextTick(() => {
                        (<any>this.$refs.dialog)?.resetPosition();
                    });
                });
        }
        previewUrl = "";
        resizeMessage() {
            this.$edMessage.destroy();
            this.$edMessage.config({
                top: window.innerHeight / 2 - 27,
            });
        }

        copyLink() {
            if (this.internal) {
                let store = localStorage;
                let list = JSON.parse(store.getItem("msgAvoidList")) || [];
                if (!list.includes("shareEditTip") && this.shareType == 1 && !this.isPreviewView) {
                    this.showShareEditTips();
                } else {
                    this.copyText("link");
                }
            } else {
                this.copyText("link");
            }
        }
        copyText(type: string) {
            const map = new Map([
                [
                    "html",
                    () => {
                        return this.shareHTML;
                    },
                ],
                [
                    "link",
                    () => {
                        const track = () => {
                            let trackType = this.shareType == 0 ? "viewonly" : "canedit";
                            let lockType = this.shareLinkCode ? "yes" : "no";
                            this.$track("share", "copy Link", `permissiontype: ${trackType}; password: ${lockType}`);
                            this.sensors.track("copyShareLink", {
                                Catalogues: "saveFileProcess",
                                savesource: "shareSave",
                                file_source: this.$store.state.user.file_source,
                                template_type: this.$store.state.user.template_type,
                                share_way: "copyShareLink",
                            });
                        };
                        track();
                        if (this.hasPass) {
                            const link = `${this.$t("copyPre1")}：${this.shareLink}`;
                            const code = ` ${this.$t("copyPre2")}：${this.shareLinkCode}`;
                            return link + code;
                        }
                        return this.isTeamsApp ? this.shareLink.replace(/online/, this.appEnv) : this.shareLink;
                    },
                ],
            ]);
            if (map.has(type)) {
                let input = document.createElement("input");
                input.value = map.get(type)();
                document.body.appendChild(input);
                input.select();
                const success = document.execCommand("copy");
                document.body.removeChild(input);
                this.$edMessage.success(this.$t(success ? "copySuccess" : "copyfail"));
            }
        }
        copyEmbedCode() {
            const input = document.createElement("input");
            input.value = this.embedCode;
            document.body.appendChild(input);
            input.select();
            const success = document.execCommand("copy");
            document.body.removeChild(input);
            this.$edMessage.success(this.$t(success ? "copySuccess" : "copyfail"));
            this.sensors.track("copyShareLink", {
                Catalogues: "saveFileProcess",
                savesource: "shareSave",
                file_source: this.$store.state.user.file_source,
                template_type: this.$store.state.user.template_type,
                share_way: "copyEmbedLink",
            });
            this.sensors.track("shareComplete", {
                Catalogues: "saveFileProcess",
                savesource: "shareSave",
                share_way: "copyEmbedLink",
            });
        }
        getCurrentExpire() {
            let data = {
                end_type: this.expireType,
                end_time: this.expireDate && this.expireType == 4 ? this.expireDate.getTime() / 1000 : "",
            };
            this.updateShareInfo(data).then((res: any) => {
                if (res?.end_time) {
                    this.expireDate = new Date(res.end_time * 1000);
                }
            });
        }

        showIframeDialog = false;

        created() {
            if (!(<any>window).qrcode) {
                addJs("js/3rd/qrcode.min.js", this.createQRCode);
            } else {
                this.createQRCode();
            }
        }

        previewUrls = [];
        mounted() {
            this.resizeMessage();
            window.addEventListener("resize", this.resizeMessage);
            this.$bus.$on("msgOperation-shareBox", async (data) => {
                if (data.sponsor == "shareBox" && data.data) {
                    const data: any = await this.updateShareInfo({ reset_link: 1 });
                    this.shareLink = data.link;
                    this.$edMessage.success(this.$t("updateSucc"));
                }
            });
            this.$bus.$on("msgOperation-shareEditSponsor", () => {
                if (this.internal) {
                    this.copyText("link");
                }
            });
            // 优先保证弹窗渲染，不要因为以下这个长耗时同步过程阻塞视图
            setTimeout(() => {
                let content = window["_view"]._doc.saveToSvgStream(131072, true);
                this.previewUrl = "data:image/svg+xml;charset=utf8," + encodeURIComponent(content.documentElement.outerHTML);

                // const list = window["_view"]._doc.saveToSvgStreamPer(131072)
                // console.log("list", list)
                // this.previewUrls = list.map(item=>{
                //     var reader = new FileReader();
                //     console.log('reader.readAsDataURL(item.blob)',reader.readAsDataURL(item.blob))
                //     return reader.readAsDataURL(item.blob)
                // })
                // console.log('previewUrls',this.previewUrls)
            }, 100);

            if (!this.showShareLoading) {
                this.initExpire();
                if (!this.isShareEdit && !this.isWorkwx) {
                    this.getShareMembers();
                }
            }
        }
        beforeDestroy() {
            this.$edMessage.destroy();
            this.$edMessage.config({
                top: 50,
            });
            window.removeEventListener("resize", this.resizeMessage);
            this.$bus.$off("msgOperation-shareBox");
            this.$bus.$off("msgOperation-shareEditSponsor");
        }
    }
</script>
<i18n>
{
  "zh": {
    "canView": "可查看",
    "canEdit": "可编辑",
    "allNetworkUser": "所有互联网用户",
    "embedTipsIn": "开启嵌入第三方后，任何在第三方网站上浏览的用户都将获得此文档的访问权限，您可以设置是否允许所有用户编辑此文件，或随时关闭分享。",
    "embedTips": "开启嵌入第三方开关后，所有互联网用户均可访问，您可随时关闭嵌入开关。",
    "howToEmbed": "如何使用嵌入功能",
    "preview": "预览",
    "topTipsClose":"分享链接已关闭",
    "topTipsHover": "只有所有者才能开启/关闭文档分享~",
    "topTips":"分享链接已开启，获得链接的人可访问",
    "title": "分享",
    "shareLink": "链接分享",
    "embedTitle": "嵌入第三方",
    "shareHTML": "嵌入第三方",
    "shareTip": "将链接分享给他人，收到链接的人可以查看，编辑您的文件",
    "delPass": "删除密码",
    "addPass": "添加密码",
    "passTip": "输入密码才能查看此文件",
    "wxTip": "请使用微信扫一扫",
    "createLink": "创建链接",
    "cancel": "取消",
    "passCode": "密码保护",
    "copySuccess": "复制成功",
    "copyFail": "复制失败",
    "copyLink": "复制链接",
    "copyCode": "复制代码",
    "copyLinkCode": "复制链接及密码",
    "copyPre1": "链接",
    "copyPre2": "密码",
    "useHTML": "复制下方代码后，在其他站点中使用",
    "view": "查看者",
    "edit": "编辑者",
    "editS": "可编辑分享",
    "shareTo": "分享至",
    "owner": "所有者",
    "viewLink": "所有人可通过链接查看该文件",
    "editLink": "所有人可通过链接编辑该文件",
    "getLink": "所有人获得链接后",
    "refreshWarning": "重置链接后，将会生成新的分享链接，当前的分享链接将会失效，并且也将无法通过旧的分享链接分享给好友。",
    "refreshWarningTitle": "您确定要重置邀请链接吗？",
    "expire1": "永久有效",
    "expire2": "7天有效",
    "expire3": "30天有效",
    "expire4": "自定义时间",
    "expire5": "1天有效",
    "expire6": "3天有效",
    "setExpire": "设置期限",
    "scanCode": "扫二维码立即分享",
    "changeCode": "换一换",
    "shareType": "分享方式",
    "joinMembers": "已加入分享的用户",
    "inviteLink": "链接邀请",
    "inviteUser": "邀请用户",
    "remove": "移出",
    "refreshLink": "重置链接",
    "updateSucc": "修改成功",
    "sendInvite": "发送邀请",
    "sendInviteSucc": "邀请发送成功",
    "email": "输入邮箱",
    "shareEditTips": "文件所有者将具有随时编辑文件的权限，当您分享至其他用户编辑时，请确保您并未在编辑文件，否则其他用户将会无法保存编辑内容。",
    "activeDateSuffix": "前有效"
  },
  "en": {
    "canView": "Reader",
    "canEdit": "Editor",
    "allNetworkUser": "All Internet users",
    "embedTipsIn": "Once Embed is enabled, all Internet users will be able to access the file. You can turn this switch off at any time.",
    "embedTips": "Once Embed is enabled, all Internet users will be able to access the file. You can turn this switch off at any time.",
    "howToEmbed": "How to use the Embed feature",
    "preview": "Preview",
    "topTipsClose":"Link sharing disabled",
    "topTipsHover": "Only the owner can enable/disable document sharing",
    "topTips":"Link sharing enabled. Can be viewed by anyone who receives the link",
    "title": "Share",
    "shareLink": "Link Share",
    "embedTitle": "Embed",
    "shareHTML": "HTML Share",
    "shareTip": "Send the link to others, then they can open and edit this file.",
    "delPass": "Delete password",
    "addPass": "Add Password",
    "passTip": "Password is required to open the file.",
    "wxTip": "Please scan the QR with Wechat",
    "createLink": "Create Link",
    "cancel": "Cancel",
    "passCode": "PassCode",
    "copySuccess": "Successfully Copied",
    "copyFail": "Copy Failed",
    "copyLink": "Copy Link",
    "copyCode": "Copy Code",
    "copyLinkCode": "Copy Link & Code",
    "copyPre1": "Link",
    "copyPre2": "PassCode",
    "useHTML": "Use in HTML",
    "view": "Can View",
    "edit": "Can Edit",
    "editS": "edit & share",
    "shareTo": "Share to",
    "owner": "Owner",
    "viewLink": "Anyone with the link can view this file",
    "editLink": "Anyone with the link can edit this file",
    "refreshWarning": "After reset, a new link will be generated, and the old link will be invalid.",
    "refreshWarningTitle": "Are you sure to reset the invitation link?",
    "expire1": "Never expire",
    "expire2": "7 days",
    "expire3": "30 days",
    "expire4": "Customize",
    "expire5": "1 day",
    "expire6": "3 days",
    "setExpire": "Time Limited",
    "scanCode": "Scan the QR code to share immediately",
    "changeCode": "Change",
    "shareType": "Share via",
    "joinMembers": "Users who have joined the collaboration",
    "inviteLink": "Invite with a link",
    "inviteUser": "Invite users",
    "remove": "Remove",
    "refreshLink": "Reset link",
    "updateSucc": "Success",
    "sendInvite": "Send Invite",
    "sendInviteSucc": "Invitation sent",
    "email": "Enter an email",
    "shareEditTips": "The file owner can edit the file at any time. Please remind that if the file owner is editing the file, other users can not save the file."
  },
  "fr": {
    "canView": "Lecteur",
    "canEdit": "Éditeur",
    "allNetworkUser": "Toute personne connectée à Internet",
    "embedTips": "Une fois l'option Intégrer activée, toutes les personnes connectées à Internet pourront accéder au fichier. Vous pouvez désactiver cette option à tout moment.",
    "howToEmbed": "Comment utiliser la fonctionnalité Intégrer",
    "preview": "Aperçu",
    "topTipsClose":"Partage de liens désactivé",
    "topTipsHover": "Seul le propriétaire peut activer/désactiver le partage de documents",
    "topTips":"Partage de liens activé. Peut être consulté par toute personne qui reçoit le lien.",
    "title": "Partager",
    "shareLink": "Partage de liens",
    "embedTitle": "Intégrer",
    "shareHTML": "Partage HTML",
    "shareTip": "Envoyer le lien à d'autres personnes, qui pourront ensuite ouvrir et afficher ce fichier.",
    "delPass": "Supprimer le mot de passe",
    "addPass": "Ajouter Mot de Passe",
    "passTip": "Un mot de passe est requis pour ouvrir le fichier.",
    "wxTip": "Veuillez scanner le QR avec Wechat",
    "createLink": "Créer un lien",
    "cancel": "Annuler",
    "passCode": "Mot de passe",
    "copySuccess": "Copier avec succès",
    "copyFail": "Échec de copie",
    "copyLink": "Copier le lien",
    "copyCode": "Copier le code",
    "copyLinkCode": "Copier le lien et le mot de passe",
    "copyPre1": "Lien",
    "copyPre2": "Mot de passe",
    "useHTML": "Copier le code ci-dessous et utiliser-le sur d'autres sites",
    "view": "Voir seulement",
    "edit": "modifiable",
    "editS": "Partage modifiable",
    "shareTo": "Partager à",
    "owner": "Propriétaire",
    "viewLink": "Toute personne disposant du lien peut consulter ce fichier",
    "editLink": "Toute personne disposant du lien peut modifier ce fichier",
    "refreshWarning": "Après la réinitialisation, un nouveau lien sera généré, ce qui annulera le précédent.",
    "refreshWarningTitle": "Êtes-vous sûr de vouloir réinitialiser le lien d'invitation ?",
    "expire1": "Ne jamais expirer",
    "expire2": "7 jours",
    "expire3": "30 jours",
    "expire4": "Personnaliser",
    "expire5": "1 jours",
    "expire6": "3 jours",
    "setExpire": "Durée limitée",
    "scanCode": "扫二维码立即分享",
    "changeCode": "Changer",
    "shareType": "Partager via",
    "joinMembers": "Accès direct",
    "inviteLink": "Inviter avec un lien",
    "inviteUser": "Inviter des utilisateurs",
    "remove": "Supprimer",
    "refreshLink": "Réinitialiser le lien",
    "updateSucc": "Réussi",
    "sendInvite": "Envoyer une invitation",
    "sendInviteSucc": "Invitation envoyée",
    "email": "Enter an email",
    "shareEditTips": "Le propriétaire du fichier peut modifier le fichier à tout moment. Veuillez vous assurer que le propriétaire du fichier ne modifie pas le fichier lors du partage avec d'autres. Sinon, les autres utilisateurs ne peuvent pas enregistrer le contenu d'édition.",
    "activeDateSuffix": "Valid until"
  },
  "de": {
    "canView": "Leser",
    "canEdit": "Redakteuer",
    "allNetworkUser": "Alle Internetbenutzer",
    "embedTips": "Sobald „Einbetten“ aktiviert ist, können alle Internetbenutzer auf die Datei zugreifen. Sie können diese Option jederzeit deaktivieren.",
    "howToEmbed": "So verwenden Sie die Funktion „Einbetten“",
    "preview": "Vorschau",
    "topTipsClose":"Link Sharing deaktiviert",
    "topTipsHover": "Nur der Besitzer kann die Dokumentfreigabe aktivieren/deaktivieren",
    "topTips":"Link Sharing aktiviert. Kann von jedem angezeigt werden, der den Link erhält.",
    "title": "Teilen",
    "shareLink": "Link teilen",
    "embedTitle": "Einbetten",
    "shareHTML": "HTML teilen",
    "shareTip": "Senden Sie den Link an andere, dann können sie diese Datei öffnen und anzeigen.",
    "delPass": "Passwort löschen",
    "addPass": "Passwort hinzufügen",
    "passTip": "Zum Öffnen der Datei ist ein Passwort erforderlich.",
    "wxTip": "Bitte scannen Sie den QR mit Wechat",
    "createLink": "Link erstellen",
    "cancel": "Abbrechen",
    "passCode": "Passwort",
    "copySuccess": "Erfolgreich kopiert",
    "copyFail": "Kopieren gescheitert",
    "copyLink": "Link kopieren",
    "copyCode": "Code kopieren",
    "copyLinkCode": "Link und Code kopieren",
    "copyPre1": "Link",
    "copyPre2": "Passwort",
    "useHTML": "In HTML einsetzn",
    "view": "Nur lesen",
    "edit": "Bearbeitbar",
    "editS": "Bearbeiten & Teilen",
    "shareTo": "Teilen an",
    "owner": "Besitzer",
    "viewLink": "Jeder mit dem Link kann diese Datei anzeigen",
    "editLink": "Jeder mit dem Link kann diese Datei bearbeiten",
    "refreshWarning": "Nach dem Zurücksetzen wird ein neuer Link generiert und der alte Link ist ungültig.",
    "refreshWarningTitle": "Sind Sie sicher, dass Sie den Einladungslink zurücksetzen möchten?",
    "expire1": "Läuft nie ab",
    "expire2": "7 Tage",
    "expire3": "30 Tage",
    "expire4": "Personalisieren",
    "expire5": "1 Tage",
    "expire6": "3 Tage",
    "setExpire": "Begrenzte Zeit",
    "scanCode": "扫二维码立即分享",
    "changeCode": "Ändern",
    "shareType": "Freigeben über",
    "joinMembers": "Direkter Zugriff",
    "inviteLink": "Mit einem Link einladen",
    "inviteUser": "Benutzer einladen",
    "remove": "Entfernen",
    "refreshLink": "Link zurücksetzen",
    "updateSucc": "Erfolg",
    "sendInvite": "Einladung senden",
    "sendInviteSucc": "Einladung senden",
    "email": "Eine Email-Adresse eingeben",
    "shareEditTips": "Der Dateibesitzer kann die Datei jederzeit bearbeiten. Stellen Sie sicher, dass der Dateibesitzer die Datei nicht bearbeitet, wenn Sie sie für die anderen Mitarbeiter freigeben. Andernfalls können andere Benutzer den Bearbeitungsinhalt nicht speichern."
  },
  "jp": {
    "canView": "閲覧者",
    "canEdit": "編集者",
    "allNetworkUser": "すべてのインターネットユーザーが",
    "embedTips": "埋め込みを有効にすると、すべてのインターネットユーザーがファイルにアクセスできるようになります。いつでもオフにすることができます。",
    "howToEmbed": "埋め込み機能の使用方法",
    "preview": "プレビュー",
    "topTipsClose":"リンク共有が無効になっています",
    "topTipsHover": "ドキュメント共有を有効または無効にできるのは所有者のみです",
    "topTips":"リンク共有が有効になりました。リンクを受信したすべてのユーザーが表示できます。",
    "title": "共有",
    "shareLink": "リンク共有",
    "embedTitle": "埋め込み",
    "shareHTML": "HTML共有",
    "shareTip": "他人にリンクを共有すると、リンクを受け取った人は共有したファイルを閲覧できます。",
    "delPass": "パスワードを削除",
    "addPass": "パスワードを追加",
    "passTip": "このファイルを閲覧するにはパスワードを入力してください",
    "wxTip": "WeChatを使用してスキャンしてください",
    "createLink": "リンクを作成",
    "cancel": "キャンセル",
    "passCode": "パスワード",
    "copySuccess": "コピー成功",
    "copyFail": "コピー失敗",
    "copyLink": "リンクをコピー",
    "copyCode": "コードをコピー",
    "copyLinkCode": "リンクとパスワードをコピー",
    "copyPre1": "リンク",
    "copyPre2": "パスワード",
    "useHTML": "以下のコードをコピーして、他のサイトで使用します",
    "view": "閲覧のみ",
    "edit": "編集可能",
    "editS": "編集・共有可能",
    "shareTo": "共有",
    "owner": "所有者",
    "viewLink": "リンクを知るユーザーは誰でもこのファイルを表示できます",
    "editLink": "リンクを知るユーザーは誰でもこのファイルを編集できます",
    "refreshWarning": "リセット後、新しいリンクが生成され、古いリンクは無効になります。",
    "refreshWarningTitle": "您确定要重置邀请链接吗？",
    "expire1": "無期限",
    "expire2": "7日間",
    "expire3": "30日間",
    "expire4": "カスタマイズ",
    "expire5": "1日間",
    "expire6": "3日間",
    "setExpire": "有効期限",
    "scanCode": "扫二维码立即分享",
    "changeCode": "更新",
    "shareType": "共有先",
    "joinMembers": "直接アクセス",
    "inviteLink": "リンクで招待",
    "inviteUser": "メールで招待",
    "remove": "削除",
    "refreshLink": "リンクをリセット",
    "updateSucc": "成功",
    "sendInvite": "招待する",
    "sendInviteSucc": "招待が送信されました",
    "email": "電子メールを入力する",
    "shareEditTips": "ファイルの所有者はいつでもファイルを編集できます。編集のために他のユーザーと共有する場合は、ファイルを編集していないことを確認してください。そうしないと、他のユーザーが編集したコンテンツを保存できなくなります。"
  },
  "es": {
    "canView": "Lector",
    "canEdit": "Editor",
    "allNetworkUser": "Todos los usuarios de Internet",
    "embedTips": "Si Integrar está activada, todos los usuarios de Internet podrán acceder al archivo. Puedes desactivarla en cualquier momento.",
    "howToEmbed": "Cómo usar la función Integrar",
    "preview": "Previsión",
    "topTipsClose":"Uso compartido de enlaces desactivado.",
    "topTipsHover": "Solo el propietario puede activar/desactivar el uso compartido de documentos",
    "topTips":"Uso compartido de enlaces activado. Pueden verlo todos los que reciban el enlace.",
    "title": "Compartir",
    "shareLink": "Compartir enlace",
    "embedTitle": "Integrar",
    "shareHTML": "Compartir HTML",
    "shareTip": "Envíe el enlace a otros, entonces ellos pueden abrir y ver este archivo",
    "delPass": "Borrar la contraseña",
    "addPass": "Agregar contraseña",
    "passTip": "Se requiere una contraseña para abrir el archivo",
    "wxTip": "Por favor, escanee el QR con Wechat",
    "createLink": "Crear un enlace",
    "cancel": "Cancelar",
    "passCode": "Contraseña",
    "copySuccess": "Copiado con éxito",
    "copyFail": "Copia fallida",
    "copyLink": "Copiar enlace",
    "copyCode": "Copiar código",
    "copyLinkCode": "Copiar enlace y código",
    "copyPre1": "Enlace",
    "copyPre2": "Contraseña",
    "useHTML": "Uso en HTML",
    "view": "ver",
    "edit": "Editar ",
    "editS": "Editar y compartir",
    "shareTo": "Compartir a",
    "owner": "Propietario",
    "viewLink": "Cualquier persona con el enlace puede ver el archivo",
    "editLink": "Cualquier persona con el enlace puede editar el archivo",
    "refreshWarning": "Tras el reinicio, se generará un nuevo enlace y el antiguo no será válido.",
    "refreshWarningTitle": "¿Estás seguro de restablecer el enlace de invitación?",
    "expire1": "No expira",
    "expire2": "7 días",
    "expire3": "30 días",
    "expire4": "Personalizar",
    "expire5": "1 días",
    "expire6": "3 días",
    "setExpire": "Tiempo Limitado",
    "scanCode": "扫二维码立即分享",
    "changeCode": "Cambiar",
    "shareType": "Compartir vía",
    "joinMembers": "Acceso Directo",
    "inviteLink": "Invitar con un enlace",
    "inviteUser": "Invite users",
    "remove": "Remover",
    "refreshLink": "Reestablecer enlace",
    "updateSucc": "Éxito",
    "sendInvite": "Enviar Invitación",
    "sendInviteSucc": "Invitación enviada",
    "email": "Introduce un correo electrónico",
    "shareEditTips": "El propietario del archivo puede editarlo en cualquier momento. Asegúrese de que el propietario del archivo no esté editando el archivo cuando lo comparta con otros. De lo contrario, otros usuarios no podrán guardar el contenido de edición."
  },
  "pt": {
    "canView": "Leitor",
    "canEdit": "Editor",
    "allNetworkUser": "Todos os usuários da Internet",
    "embedTips": "Quando a opção Incorporar estiver habilitada, todos os usuários da Internet poderão acessar o arquivo. Você pode desativar essa opção a qualquer momento.",
    "howToEmbed": "Como usar o recurso Incorporar",
    "preview": "Previsualização",
    "topTipsClose":"Compartilhamento de link desativado",
    "topTipsHover": "Somente o proprietário pode ativar/desativar o compartilhamento de documentos",
    "topTips":"Compartilhamento de link ativado. Pode ser visualizado por qualquer pessoa que receber o link.",
    "title": "Partilhar",
    "shareLink": "Partilha de Ligação",
    "embedTitle": "Incorporar",
    "shareHTML": "Partilha HTML",
    "shareTip": "Enviar a ligação a outros, para poderem abrir e visualizar este ficheiro.",
    "delPass": "Eliminar password",
    "addPass": "Adicionar Password",
    "passTip": "É requerida password para abrir o ficheiro.",
    "wxTip": "Por favor, digitalizar o QR com o WeChat",
    "createLink": "Criar Ligação",
    "cancel": "Cancelar",
    "passCode": "Senha",
    "copySuccess": "Copiado com Sucesso",
    "copyFail": "Cópia Falhada",
    "copyLink": "Copiar Ligação",
    "copyCode": "Copiar código",
    "copyLinkCode": "Copiar Ligação & Código",
    "copyPre1": "Ligação",
    "copyPre2": "Senha",
    "useHTML": "Usar em HTML",
    "view": "Ver",
    "edit": "Editar",
    "editS": "editar e compartilhar",
    "shareTo": "compartilhar com",
    "owner": "Proprietário",
    "viewLink": "Qualquer pessoa com o link pode visualizar este arquivo",
    "editLink": "Qualquer pessoa com o link pode editar este arquivo",
    "refreshWarning": "Depois de redefinir, um novo link será gerado e o link antigo será inválido.",
    "refreshWarningTitle": "Tem certeza de que deseja redefinir o link do convite?",
    "expire1": "Nunca expira",
    "expire2": "7 dias",
    "expire3": "30 dias",
    "expire4": "Customizar",
    "expire5": "1 dias",
    "expire6": "3 dias",
    "setExpire": "Tempo Limitado",
    "scanCode": "扫二维码立即分享",
    "changeCode": "Mudar",
    "shareType": "Compartilhar via",
    "joinMembers": "Acesso Direto",
    "inviteLink": "Convidar com um link",
    "inviteUser": "Convidar usuários",
    "remove": "Remover",
    "refreshLink": "Redefinir link",
    "updateSucc": "Sucesso",
    "sendInvite": "Enviar Convite",
    "sendInviteSucc": "Convite enviado",
    "email": "Digite um e-mail",
    "shareEditTips": "O proprietário do arquivo pode editar o arquivo a qualquer momento. Por favor, certifique-se de que o proprietário do arquivo não está editando o arquivo quando compartilhar com outros. Caso contrário, os outros usuários não poderão salvar o conteúdo de edição."
  },
  "it": {
    "canView": "Lettore",
    "canEdit": "Redattore",
    "allNetworkUser": "Tutti gli utenti Internet",
    "embedTips": "Una volta abilitata la funzione Incorpora, tutti gli utenti Internet potranno accedere al file. È possibile disattivare in qualsiasi momento.",
    "howToEmbed": "Come utilizzare la funzione Incorpora",
    "preview": "Anteprima",
    "topTipsClose":"Condivisione del collegamento disabilitata.",
    "topTipsHover": "Solo il proprietario può abilitare/disabilitare la condivisione del documento",
    "topTips":"Condivisione del collegamento abilitata. Il contenuto può essere visualizzato da chiunque riceva il collegamento.",
    "title": "Condividi",
    "shareLink": "Condividi Collegamento",
    "embedTitle": "Incorpora",
    "shareHTML": "Condividi HTML",
    "shareTip": "Invia il collegamento ad altre persone, per consentire loro di aprire e visualizzare il file.",
    "delPass": "Elimina Password",
    "addPass": "Aggiungi Password",
    "passTip": "Sarà richiesta una password per aprire il file.",
    "wxTip": "Bisogna scansionare il codice QR usando Wechat",
    "createLink": "Crea Collegamento",
    "cancel": "Annulla",
    "passCode": "PassCode",
    "copySuccess": "Copia Eseguita con Successo",
    "copyFail": "Copia Fallita",
    "copyLink": "Copia Collegamento",
    "copyCode": "Copia codice",
    "copyLinkCode": "Copia Collegamento e Codice",
    "copyPre1": "Collegamento",
    "copyPre2": "PassCode",
    "useHTML": "Usa HTML",
    "view": "Visualizzare solamente",
    "edit": "Modificabile",
    "editS": "Condivisibile e modificabile",
    "shareTo": "Condividi su",
    "owner": "Proprietario",
    "viewLink": "Tutte le persone con il collegamento possono visualizzare il file",
    "editLink": "Tutte le persone con il collegamento possono modificare il file",
    "refreshWarning": "Dopo il ripristino, verrà generato un nuovo link e il vecchio link non sarà valido.",
    "refreshWarningTitle": "Sei sicuro di reimpostare il link di invito?",
    "expire1": "Non scade mai",
    "expire2": "7 giorni",
    "expire3": "30 giorni",
    "expire4": "Personalizza",
    "expire5": "1 giorni",
    "expire6": "3 giorni",
    "setExpire": "Tempo limitato",
    "scanCode": "扫二维码立即分享",
    "changeCode": "Modifica",
    "shareType": "Condivide tramite",
    "joinMembers": "Accesso Diretto",
    "inviteLink": "Invita con un link",
    "inviteUser": "Invita gli utenti",
    "remove": "Rimuove",
    "refreshLink": "Reimposta link",
    "updateSucc": "Successo",
    "sendInvite": "Manda un invito",
    "sendInviteSucc": "Invito spedito",
    "email": "Inserisci un'e-mail",
    "shareEditTips": "Il proprietario del file può modificare il file in qualsiasi momento. Assicurati che il proprietario del file non stia modificando il file quando lo condividi con altri. In caso contrario, gli altri utenti non potranno salvare il contenuto della modifica."
  },
  "tw": {
    "canView": "閱讀者",
    "canEdit": "編輯者",
    "allNetworkUser": "",
    "embedTips": "",
    "howToEmbed": "",
    "preview": "預覽",
    "topTipsClose": "分享連結已停用",
    "topTipsHover": "僅限擁有者可以啟用/停用文件分享",
    "topTips":"分享連結已啟用。收到連結的任何人員都可以檢視。",
    "title": "分享",
    "shareLink": "連結分享",
    "embedTitle": "",
    "shareHTML": "HTML分享",
    "shareTip": "將連結分享給他人，收到連結的人可以查看，編輯您的檔案",
    "delPass": "刪除密碼",
    "addPass": "添加密碼",
    "passTip": "輸入密碼才能查看此檔案",
    "wxTip": "請使用微信掃一掃",
    "createLink": "建立連結",
    "cancel": "取消",
    "passCode": "密碼",
    "copySuccess": "複製成功",
    "copyFail": "複製失敗",
    "copyLink": "複製連結",
    "copyCode": "複製代碼",
    "copyLinkCode": "複製連結及密碼",
    "copyPre1": "連結",
    "copyPre2": "密碼",
    "useHTML": "複製下方代碼後，在其他站點中使用",
    "view": "進查看",
    "edit": "可編輯",
    "editS": "可編輯分享",
    "shareTo": "分享至",
    "owner": "所有者",
    "viewLink": "任何擁有連結的人員都可以檢視此檔案",
    "editLink": "任何擁有連結的人員都可以編輯此檔案",
    "refreshWarning": "重置链接后，将会生成新的分享链接，当前的分享链接将会失效，并且也将无法通过旧的分享链接分享给好友。",
    "refreshWarningTitle": "您确定要重置邀请链接吗？",
    "expire1": "永久有效",
    "expire2": "7天有效",
    "expire3": "30天有效",
    "expire4": "自定义时间",
    "expire5": "1天有效",
    "expire6": "3天有效",
    "setExpire": "设置期限",
    "scanCode": "扫二维码立即分享",
    "changeCode": "换一换",
    "shareType": "分享方式",
    "joinMembers": "已加入分享的用户",
    "inviteLink": "邀請連結",
    "inviteUser": "邀請用戶",
    "remove": "移出",
    "refreshLink": "重置链接",
    "updateSucc": "修改成功",
    "sendInvite": "发送邀请",
    "sendInviteSucc": "邀请发送成功",
    "email": "輸入郵箱",
    "shareEditTips": "檔案所有者可以隨時編輯檔案。 請注意，如果檔案所有者正在編輯檔案，則其他用戶將無法儲存該檔案。"
  },
  "kr": {
    "canView": "조회자",
    "canEdit": "편집자",
    "allNetworkUser": "",
    "embedTips": "",
    "howToEmbed": "",
    "preview": "미리 보기",
    "topTipsClose": "링크 공유가 비활성화되었습니다.",
    "topTipsHover": "소유자만 문서 공유를 활성화/비활성화할 수 있습니다.",
    "topTips":"링크 공유가 활성화되었습니다. 링크를 받은 모든 사람이 볼 수 있습니다.",
    "title": "공유",
    "shareLink": "링크 공유",
    "embedTitle": "",
    "shareHTML": "HTML 공유",
    "shareTip": "다른 사용자에게 링크를 보내면 해당 사용자가 이 파일을 열고 편집할 수 있습니다.",
    "delPass": "비밀번호 삭제",
    "addPass": "비밀번호 추가",
    "passTip": "이 파일을 볼 수 있도록 비밀번호를 입력하세요",
    "wxTip": "위챗으로 QR 스캔해 주세요.",
    "createLink": "링크 만들기",
    "cancel": "취소",
    "passCode": "비밀번호",
    "copySuccess": "성공적으로 복사됨",
    "copyFail": "복사 실패",
    "copyLink": "링크 복사",
    "copyCode": "코드 복사",
    "copyLinkCode": "링크 & 비밀번호 복사",
    "copyPre1": "링크",
    "copyPre2": "비밀번호",
    "useHTML": "아래쪽 코드를 복사 후 다른 사이트에서 사용",
    "view": "보기만",
    "edit": "편집 가능",
    "editS": "편집 공유 가능",
    "shareTo": "공유 대상",
    "owner": "생성인",
    "viewLink": "링크가 있는 모든 사람이 이 파일을 볼 수 있습니다.",
    "editLink": "링크가 있는 모든 사람이 이 파일을 편집할 수 있습니다.",
    "refreshWarning": "재설정 후 새 링크가 생성되며 이전 링크는 무효가 됩니다.",
    "refreshWarningTitle": "초대 링크를 재설정하겠습니까?",
    "expire1": "영구 유효",
    "expire2": "7일",
    "expire3": "30일",
    "expire4": "사용자 지정",
    "expire5": "1일",
    "expire6": "3일",
    "setExpire": "시간 제한",
    "scanCode": "扫二维码立即分享",
    "changeCode": "변경",
    "shareType": "공유 채널",
    "joinMembers": "직접 액세스",
    "inviteLink": "링크 공유",
    "inviteUser": "사용자 요청",
    "remove": "지우기",
    "refreshLink": "링크 다시 설정",
    "updateSucc": "성공",
    "sendInvite": "초대하기",
    "sendInviteSucc": "초대 완료",
    "email": "이메일 입력",
    "shareEditTips": "파일 소유자는 언제든지 파일을 편집할 수 있습니다. 파일 소유자가 파일을 편집하는 경우 다른 사용자가 파일을 저장할 수 없습니다."
  }
}
</i18n>
